const Unauthorized = () => {
    return (
        <>
            <div className="min-h-full h-screen px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8">
                <div className="mx-auto max-w-max">
                    <main className="sm:flex">
                        <p className="text-4xl font-bold tracking-tight text-blue-600 sm:text-5xl">403</p>
                        <div className="sm:ml-6">
                            <div className="sm:border-l sm:border-gray-200 sm:pl-6">
                                <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">Access Denied</h1>
                                <p className="mt-1 text-base text-gray-500">You are not allowed to access this page.<br />If you believe this is an error, please contact the administrators of the website.</p>
                            </div>
                            <div className="mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6">
                                <a
                                    href="/"
                                    className="inline-flex items-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                >
                                    Go back home
                                </a>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        </>
    );
}

export default Unauthorized;
